import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const path = "common/global-settings";

export const Add = async (values) => {
  const options = { role: ROLE.SUPER_ADMIN };
  return await axiosInstance(options).post(`admin/global-settings`, values);
};

export const Details = async () => {
  return await axiosInstance().get(`${path}/details`);
};


